import React from 'react';
import { Box, Typography, Paper, Button, Container } from '@mui/material';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import DashboardIcon from '@mui/icons-material/Dashboard';
import LoginIcon from '@mui/icons-material/Login';

const PaymentFailed = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const { user } = useAuth();
  const reason = searchParams.get('reason');
  const isInvoiceCancelled = reason === 'invoice_cancelled' || reason === 'cancelled';
  const isExpired = reason === 'expired';
  const isAlreadyPaid = reason === 'already_paid';
  const isNotFound = reason === 'not_found';

  const handleGoToDashboard = () => {
    if (user) {
      navigate('/dashboard', { replace: true });
    } else {
      navigate('/auth/login', { state: { from: { pathname: '/dashboard' } }, replace: true });
    }
  };

  return (
    <Box
      sx={{
        minHeight: '100vh',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        bgcolor: '#f3f6fb',
        py: 4,
      }}
    >
      <Container maxWidth="sm">
        <Paper
          elevation={0}
          sx={{
            p: 4,
            borderRadius: 3,
            textAlign: 'center',
            backgroundColor: '#fff',
            border: '1px solid',
            borderColor: 'divider',
          }}
        >
          <Box sx={{ mb: 3, display: 'flex', justifyContent: 'center' }}>
            <ErrorOutlineIcon
              sx={{ fontSize: 72, color: 'error.main' }}
              aria-hidden
            />
          </Box>
          <Typography variant="h5" component="h1" fontWeight="bold" gutterBottom>
            {isInvoiceCancelled && 'Invoice cancelled'}
            {isExpired && 'Link expired'}
            {isAlreadyPaid && 'Already paid'}
            {isNotFound && 'Link invalid'}
            {!isInvoiceCancelled && !isExpired && !isAlreadyPaid && !isNotFound && 'Payment failed'}
          </Typography>
          <Typography variant="body1" color="text.secondary" sx={{ mb: 3 }}>
            {isInvoiceCancelled &&
              'This invoice has been cancelled. No payment was taken. Please contact support if you need a new payment link.'}
            {isExpired &&
              'This payment link has expired. Please contact support for a new link.'}
            {isAlreadyPaid &&
              'This invoice has already been paid.'}
            {isNotFound &&
              'This payment link is invalid or no longer available. Please contact support.'}
            {!isInvoiceCancelled && !isExpired && !isAlreadyPaid && !isNotFound &&
              'Your payment could not be completed. Please try again or contact support if the issue persists.'}
          </Typography>

          <Button
            variant="contained"
            size="large"
            startIcon={user ? <DashboardIcon /> : <LoginIcon />}
            onClick={handleGoToDashboard}
            sx={{ py: 1.5, minWidth: 200 }}
          >
            {user ? 'Go to Dashboard' : 'Go to Login'}
          </Button>
        </Paper>
      </Container>
    </Box>
  );
};

export default PaymentFailed;
